import React, { useEffect, useState } from "react";
import classes from "./voteNowPage.module.css";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchActiveContests } from "../../redux/slices/andArenaSlice";

const VoteNowPage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [countdown, setCountdown] = useState({
    days: 5,
    hours: 10,
    minutes: 14,
    seconds: 39,
  });

  const activeContests = useSelector((state) => state.andArena.activeContests);
  // const activeContests = [];
  // Fetch active contests when the component mounts
  useEffect(() => {
    dispatch(
      fetchActiveContests({
        page_number: 1,
        page_size: 10,
      })
    );
  }, [dispatch]);

  // Countdown timer logic
  useEffect(() => {
    if (!activeContests || activeContests.length === 0) return;

    // Find the soonest contest end date
    const sortedContests = [...activeContests].sort(
      (a, b) => new Date(a.end_date) - new Date(b.end_date)
    );
    const targetDate = new Date(sortedContests[0].end_date);

    const updateCountdown = () => {
      const now = new Date();
      const diff = targetDate - now;

      if (diff <= 0) {
        setCountdown({ days: 0, hours: 0, minutes: 0, seconds: 0 });
        return;
      }

      const seconds = Math.floor((diff / 1000) % 60);
      const minutes = Math.floor((diff / 1000 / 60) % 60);
      const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
      const days = Math.floor(diff / (1000 * 60 * 60 * 24));

      setCountdown({ days, hours, minutes, seconds });
    };

    updateCountdown(); // initialize immediately
    const timer = setInterval(updateCountdown, 1000);

    return () => clearInterval(timer);
  }, [activeContests]);

  // If active contests is empty, return a loading state
  if (!activeContests || activeContests.length === 0) {
    return <div>Loading contests...</div>;
  }

  // Map categories and icons
  const categoryIcons = {
    singer: "🎤",
    dancer: "🕺",
    musician: "🎸",
    rapper: "💬",
    magician: "🧙‍♂️",
    comedian: "🎭",
    photography: "📷",
    video_editor: "🎬",
  };

  const handleCategoryClick = (label) => {
    label = label.toLowerCase();
    let modifiedLabel = label.replace(/\s+/g, "-"); // Replace all spaces with hyphens
    navigate(`/artist-next-door-arena/contests/${modifiedLabel}`);
  };

  return (
    <div className={classes.container}>
      <div className={classes.quoteBanner}>
        <div className={classes.quoteLeft}>
          <p>
            "The only thing better than singing is more singing." - Ella
            Fitzgerald
          </p>
        </div>
        <div className={classes.quoteRight}>
          <p>"Reality is wrong. Dreams are for real." - Tupac Shakur</p>
        </div>
      </div>

      <div className={classes.mainContent}>
        <div className={classes.header}>
          <h1 className={classes.pageTitle}>Live weekly contests</h1>

          <div className={classes.countdownContainer}>
            {Object.entries(countdown).map(([unit, value]) => (
              <div key={unit} className={classes.countdownItem}>
                <div className={classes.countdownBox}>
                  <span className={classes.countdownValue}>{value}</span>
                </div>
                <span className={classes.countdownLabel}>{unit}</span>
              </div>
            ))}
          </div>
        </div>

        <div className={classes.categoriesGrid}>
          {activeContests.map((contest) => {
            const { category, id, label } = contest;
            const icon = categoryIcons[category] || "🎤"; // Default to 🎤 if no icon is found

            return (
              <div
                key={id}
                className={`${classes.categoryCard}`}
                onClick={() => handleCategoryClick(label)}
              >
                <div className={classes.categoryIcon}>{icon}</div>
                <h2 className={classes.categoryName}>{label?.toUpperCase()}</h2>
              </div>
            );
          })}
        </div>

        <div className={classes.tipSection}>
          <p>
            Tip 💡: Select the category you want to vote for, visit the
            leaderboard to view how your favourite artist is doing.
          </p>
        </div>
      </div>
    </div>
  );
};

export default VoteNowPage;
